// angular
import { HttpClient } from '@angular/common/http';
import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from '../../core/auth.service';

// others
import { AppService } from '../../app.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'me-landing-page-footer',
    templateUrl: './landing-page-footer.component.html',
    styleUrls: ['./landing-page-footer.component.scss'],
})

export class MeLandingPageFooterComponent implements OnInit, OnDestroy {
    data: any;
    subLanguage: Subscription;
    subFolder: Subscription;
    language = this.translate.currentLang;
    country = this.appService.getMeClinicFolder() ?? 'core';
    languages = this.appService.meLanguages;
    countries = [
        {
            name: 'Germany',
            locale: 'core',
        },
        {
            name: 'Switzerland',
            locale: 'ch'
        }
    ];
    url = 'lp/footer';

    constructor(
        public appService: AppService,
        public authService: AuthService,
        public translate: TranslateService,
        public http: HttpClient,
        @Inject('storyBlokToken') public storyBlokToken: string,
    ) {
    }

    ngOnInit() {
        this.getContent();
        this.subLanguage = this.translate.onLangChange.subscribe(value => {
            this.language = this.translate.currentLang;
            this.getContent();
        });

        this.subFolder = this.appService.meClinicFolderChanged.subscribe(value => {
            if (value != '') {
                this.country = value;
                this.getContent();
            }
        });
    }

    ngOnDestroy() {
        this.subFolder.unsubscribe();
        this.subLanguage.unsubscribe();
    }

    getContent() {
        this.appService.getStoryBlokDataForClinic(this.url).subscribe(res => {
            this.data = res['story']['content'] ?? [];

            //Render login button
            // this.data.internalLinks.forEach(link => {
            //     if (link.url && link.url.cached_url === '/login' && this.authService.isLoggedIn) {
            //         link.url.cached_url = '/dashboard';
            //         link.url.url = '/dashboard';
            //     }
            // });
        });
    }

    changeLanguage() {
        this.appService.setLanguage(this.language);
    }

    changeContry() {
        this.appService.setMeClinicFolder(this.country);

        if (this.country != 'core') {
            let url = 'https://api.storyblok.com/v2/cdn/stories/' + this.country + '/config/?token=' + this.storyBlokToken;
            this.http.get(url).subscribe(res => {
                if (res['story']) {
                    this.appService.setMeClinicConfig(JSON.stringify(res['story']['content']));
                    this.appService.setMeClinicId(res['story']['content']['clinicId']);
                }
            });
        } else {
            let url = 'https://api.storyblok.com/v2/cdn/stories/main/config/?token=' + this.storyBlokToken;
            this.http.get(url).subscribe(res => {
                if (res['story']) {
                    this.appService.setMeClinicConfig(JSON.stringify(res['story']['content']));
                    this.appService.setMeClinicId(res['story']['content']['clinicId']);
                }
            });
        }
    }
}
